<template>
      <div class="OrderPage" id="OrderPage">
            <header-component></header-component>
            <!-- <pre>
                  {{ Order }}
            </pre> -->
             <!-- v-prevent-back.vue-router-disable -->
            <div class="g-bg-gray" v-prevent-back.vue-router-disable>
                  <div class="container-fluid">

                        <div v-if="isLoadFinish && isVoucherLoadFinish && isAccountFinishLoading" class="row">
                              <div v-if="isOrderValid" class="col-lg-8 offset-lg-2 g-pt-70 g-pb-100" style="background-color: white; padding: 50px; border-radius: 10px; box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);">
                                    <br>
                                    <p class="page-title">Order Page</p>
                                    <div v-show="isSubmitFail" id="errorDivOrder" class="alert alert-danger alert-dismissible fade show" role="alert">
                                          <button type="button" @click="isSubmitFail = false" class="close" data-dismiss="alert" aria-label="Close">
                                                <span aria-hidden="true">&times;</span>
                                          </button>
                                          <h4 class="alert-heading">Attention!</h4>
                                          <p class="mb-0">Please complete the form to proceed with the submission</p>
                                    </div>
                                    <div v-if="Order.ErrorMessage" id="errorDivOrder" class="alert alert-danger alert-dismissible fade show" role="alert">
                                          <h4 class="alert-heading">Attention!</h4>
                                          <p class="mb-0">{{Order.ErrorMessage}}</p>
                                    </div>
                                    <div v-if="isThreshHoldShown" id="errorDivOrder" class="alert alert-warning alert-dismissible fade show" role="alert">
                                          <button type="button" @click="isThreshHoldShown = false" class="close" data-dismiss="alert" aria-label="Close">
                                                <span aria-hidden="true">&times;</span>
                                          </button>
                                          <h4 class="alert-heading">Attention!</h4>
                                          <p class="mb-0">You have {{Capping.orderCap - Capping.orderCount}} orders remaining on your account. After the number is reached you will no longer be able to place orders. For more information,
                                                <a href="#" @click="ToggleHelpForm()">contact us</a>.</p>
                                    </div>
                                    <div v-if="isorderCapMet" id="errorDivOrder" class="alert alert-danger alert-dismissible fade show" role="alert">
                                          <h4 class="alert-heading">Attention!</h4>
                                          <p class="mb-0">You have reached your order limit and are no longer able to submit any orders. For more information,
                                                <a href="#" @click="ToggleHelpForm()">contact us</a>.</p>
                                    </div>

      <div class="row div-spacing-top" v-if="(MasterAccountType == 'master') && $route.params.code">
        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
            <div class="order-title">
                Participant Account Information
            </div>
        </div>
        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 div-spacing-top">
            <div class="row no-gutters order-div">
                <div v-if="true" class="col-lg-12 col-md-12 col-sm-12 col-xs-12 div-spacing-top">
                    <div v-if="true" class="row">
                        <div class="col-lg-8 offset-lg-2">
                            <div class="form-group">
                                <label class="order-confirmation-label">Participant Name:</label>
                                <span v-if='Account.accountType==1' class="order-confirmation-description">{{Account.primaryContact.firstName}} {{Account.primaryContact.lastName}}</span>
                                <span v-else class="order-confirmation-description">{{Account.primaryContact.legalName}}</span>
                            </div>
                        </div>
                        <div class="col-lg-8 offset-lg-2">
                            <div class="form-group">
                                <label class="order-confirmation-label">Participant Login Email:</label>
                                <span class="order-confirmation-description">{{Account.emailAddress}}</span>
                            </div>
                        </div>
                        <div class="col-lg-8 offset-lg-2">
                            <div class="form-group">
                                <label class="order-confirmation-label">EVF ID:</label>
                                <span class="order-confirmation-description">{{Account.evfAccountNumber}}</span>
                            </div>
                        </div>
                        <div class="col-lg-8 offset-lg-2">
                            <div class="form-group">
                                <label class="order-confirmation-label">Salesforce ID:</label>
                                <a href="#"  class="order-confirmation-description">{{Account.salesforceId}}</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
      </div>
                                    <participant-account-information v-if="MasterAccountType == 'master' && !$route.params.code" :Order="Order" @search="AccountValue"></participant-account-information>
                                    <general-information :Order="Order" :Account="Account" :Voucher="Voucher" :State="State" :ReferralOrgSelect="ReferralOrgSelect" :VoucherList="VoucherList" :Suffix="Suffix" :ValidationResult="ValidationResult"></general-information>
                                    <patient-information ref="patient" v-if="!MasterAccountType && $route.params.EditOrReuse != 1" :Order="Order" :Ethnicity="Ethnicity" :ValidationResult="ValidationResult"></patient-information>
                                    <order-information v-if="!Order.IsExamOnly" :Order="Order" :ValidationResult="ValidationResult" :MasterAccountType="MasterAccountType" :PrismDirection="PrismDirection"></order-information>
                                    <frame-information v-if="!Order.IsExamOnly" @help="ToggleHelpForm()" :Order="Order" :ValidationResult="ValidationResult" :Capping="Capping" :MasterAccountType="MasterAccountType" :isFrameLensServiceFee="Account.isFrameLensServiceFee" :Account="Account"></frame-information>
                                    <additional-information :Order="Order" :Account="Account" :State="State" :MasterAccountType="MasterAccountType" :ValidationResult="ValidationResult"></additional-information>
                                    <p class="order-payment" style="background-color:#d5e4ef7a" v-if="!isorderCapMet && MasterAccountType != 'master' && Account.isStandardOrderServiceFee && Order.JobType != 'LSF'">Please note: After you submit, you will be charged a service fee for this order.</p>
                                    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 div-spacing-top">
                                          <div class="row  text-center">
                                                <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 g-mt-15" v-if="!Order.IsExamOnly">
                                                      <button v-on:click="ValidateOrder('true', 'false', 'true')" class="btn g-color-white g-bg-main g-bg-main-blue--hover g-rounded-10 g-font-size-18">Save as Pending Order</button>
                                                </div>
                                                <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 g-mt-15" v-bind:class="{ 'col-lg-6 col-md-6': !Order.IsExamOnly, 'col-md-12 col-lg-12': Order.IsExamOnly }">
                                                      <button type="button" v-if="!Order.IsExamOnly && !Order.DoesNotMeetRequirements && AccountStatus != 'OrderHoldUnderReview' && !isorderCapMet && ((Capping.frameLensCount < Capping.frameLensCap && Order.JobType == 'LSF') || !Capping.isFrameLensCapOn)" v-on:click="ValidateOrder('false', 'false', 'true', 'false')" class="btn g-color-white u-btn-primary g-rounded-10 g-font-size-18">Review and Submit Order</button>
                                                      <button type="button" v-else-if="Order.IsExamOnly" v-on:click="SubmitExamOnlyOrder()" class="btn g-color-white u-btn-primary g-rounded-10 g-font-size-18">Save</button>
                                                      <button type="button" v-else-if="AccountStatus != 'OrderHoldUnderReview' && isorderCapMet" v-on:click="ValidateOrder('false', 'false', 'true', 'false')" class="btn g-color-white u-btn-primary g-rounded-10 g-font-size-18" v-bind:disabled="true">Review and Submit Order</button>
                                                      <button type="button" v-else-if="AccountStatus != 'OrderHoldUnderReview' && isorderCapMet && MasterAccountType == 'master'" v-on:click="ValidateOrder('false', 'false', 'true', 'false')" class="btn g-color-white u-btn-primary g-rounded-10 g-font-size-18">Review and Submit Order</button>
                                                      <button type="button" v-else-if="AccountStatus != 'OrderHoldUnderReview' && Order.JobType == 'LSF' && (Capping.frameLensCount >= Capping.frameLensCap) && MasterAccountType != 'master' && Capping.isFrameLensCapOn" v-on:click="ValidateOrder('false', 'false', 'true', 'false')" class="btn g-color-white u-btn-primary g-rounded-10 g-font-size-18" v-bind:disabled="true">Review and Submit Order</button>
                                                      <button type="button" v-else-if="AccountStatus != 'OrderHoldUnderReview' && Order.JobType == 'LSF' && (Capping.frameLensCount < Capping.frameLensCap) && MasterAccountType == 'master'" v-on:click="ValidateOrder('false', 'false', 'true', 'false')" class="btn g-color-white u-btn-primary g-rounded-10 g-font-size-18">Review and Submit Order</button>
                                                      <button type="button" v-else-if="(!Order.DoesNotMeetRequirements && AccountStatus == 'OrderHoldUnderReview') || (Order.DoesNotMeetRequirements && AccountStatus == 'OrderHoldUnderReview')" v-on:click="ValidateOrder('false', 'false', 'true', 'false')" class="btn g-color-white u-btn-primary g-rounded-10 g-font-size-18" v-bind:disabled="true">Review and Submit Order</button>
                                                      <button type="button" v-else-if="Order.DoesNotMeetRequirements == true && MasterAccountType == 'master' && $route.params.code && this.$route.params.EditOrReuse != 1" v-on:click="ValidateOrder('true', 'true', 'false', 'true')" class="btn g-color-white u-btn-primary g-rounded-10 g-font-size-18">Approve Special Order</button>
                                                      <button type="button" v-else-if="Order.DoesNotMeetRequirements == true && MasterAccountType == 'master' && $route.params.code && this.$route.params.EditOrReuse == 1" v-on:click="ValidateOrder('true', 'true', 'false', 'true')" class="btn g-color-white u-btn-primary g-rounded-10 g-font-size-18">Submit Special Order</button>
                                                      <button type="button" v-else-if="Order.DoesNotMeetRequirements == true && MasterAccountType != 'master'" v-on:click="ValidateOrder('false', 'false', 'true', 'false')" class="btn g-color-white u-btn-primary g-rounded-10 g-font-size-18">Review and Submit for Approval</button>
                                                      <button type="button" v-else-if="Order.DoesNotMeetRequirements == true && MasterAccountType != 'master'" v-on:click="ValidateOrder('false', 'false', 'true', 'false')" class="btn g-color-white u-btn-primary g-rounded-10 g-font-size-18">Review and Submit for Approval</button>
                                                      <button type="button" v-else v-on:click="ValidateOrder('false', 'false', 'true', 'false')" class="btn g-color-white u-btn-primary g-rounded-10 g-font-size-18">Review and Submit Order</button>
                                                </div>
                                          </div>
                                    </div>
                              </div>
                              <div v-if="!isOrderValid" class="col-lg-8 offset-lg-2 g-pt-70 g-pb-100">
                                    <div class="row">
                                          <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 center">
                                          <p class="error-message">Error!</p>
                                          <p class="order-confimation-description">
                                                Order requested is not valid.
                                          </p>
                                          </div>
                                    </div>
                              </div>
                              <div v-if="isModalReviewShown">
                                    <div class="modal-mask" role="dialog">
                                          <div class="overlay-mask">
                                                <div class="modal-dialog order-modal-size">
                                                      <div class="modal-content">
                                                            <div class="modal-body">
                                                                  <!-- <div class="close_btn" v-on:click="closeModal()"></div> -->
                                                                  <div class="passwordReset-header">
                                                                        <p class="order-review-page-title">Order Review</p>
                                                                        <p class="order-review-description" style="color: #fff;">Please review and confirm your order details before submitting.</p>
                                                                  </div>
                                                                  <div class="row">
                                                                        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                                                              <order-review :OrderReturn="OrderReturn" :Account="Account" :Voucher="Voucher"></order-review>
                                                                        </div>
                                                                        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 g-my-20">
                                                                              <div class="row">
                                                                                    <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 center">
                                                                                          <button v-on:click="closeModal()" class="btn g-color-white g-bg-main g-bg-main-blue--hover g-rounded-10 g-btn-130">Edit</button>
                                                                                    </div>
                                                                                    <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 center">
                                                                                          <button v-if="!Order.DoesNotMeetRequirements" v-on:click="ValidateOrder('true', 'true', 'false', 'false')" class="btn g-color-white u-btn-primary g-rounded-10 g-btn-130">Submit Order</button>
                                                                                          <button v-else v-on:click="ValidateOrder('true', 'true', 'false', 'false')" class="btn g-color-white u-btn-primary g-rounded-10 g-btn-130">Submit Order</button>
                                                                                    </div>
                                                                              </div>
                                                                        </div>
                                                                  </div>
                                                            </div>
                                                      </div>
                                                </div>
                                          </div>
                                    </div>
                              </div>
                              <div v-if="isSaveChangesModalShown">
                                    <div class="modal-mask" role="dialog">
                                          <div class="overlay-mask">
                                                <div class="modal-dialog modal-lg">
                                                      <div class="modal-content modal-edit-bg">
                                                            <div class="modal-body">
                                                                  <div class="close_btn" v-on:click="CloseSaveChangesModal('stay')"></div>
                                                                  <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 g-mt-30 g-mb-30">
                                                                        <h5>
                                                                        Are you sure you want to leave this page? Your order information will not be saved.  To save the info, please select “Save as Pending Order” at the bottom of the page.
                                                                        </h5>
                                                                  </div>
                                                                  <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 center g-pb-10">
                                                                        <button class="btn g-color-white u-btn-primary g-rounded-10 g-btn-130" v-on:click="CloseSaveChangesModal('leave')">Leave this page</button>
                                                                        <button class="btn g-color-white u-btn-primary g-rounded-10 g-btn-130" v-on:click="CloseSaveChangesModal('stay')">Stay on this page</button>
                                                                  </div>
                                                            </div>
                                                      </div>
                                                </div>
                                          </div>
                                    </div>
                              </div>
                        </div>
                        <div v-if="!isLoadFinish || !isVoucherLoadFinish || !isAccountFinishLoading" class="row g-pt-100">
                              <page-loader></page-loader>
                        </div>
                        <loading-component v-if="isSubmitFinish"></loading-component>
                  </div>
            </div>
            <footer-component></footer-component>
      </div>
</template>
<script>
import HeaderComponent from "@/components/shared/HeaderComponent";
import FooterComponent from "@/components/shared/FooterComponent";
import HelpForm from "@/components/shared/HelpForm";
import ParticipantAccountInformation from "@/components/portal/Order/OrderComponent/ParticipantAccountInformation";
import GeneralInformation from "@/components/portal/Order/OrderComponent/GeneralInformation";
import PatientInformation from "@/components/portal/Order/OrderComponent/PatientInformation";
import OrderInformation from "@/components/portal/Order/OrderComponent/OrderInformation";
import FrameInformation from "@/components/portal/Order/OrderComponent/FrameInformation";
import AdditionalInformation from "@/components/portal/Order/OrderComponent/AdditionalInformation";
import OrderReview from "@/components/portal/Order/OrderComponent/OrderReview";
import PageLoader from "@/components/shared/PageLoader";
import LoadingComponent from "@/components/shared/LoadingComponent";
export default {
      components: {HeaderComponent, FooterComponent, GeneralInformation,PatientInformation,
                   OrderInformation, FrameInformation, AdditionalInformation, OrderReview, PageLoader,
                   LoadingComponent, ParticipantAccountInformation, HelpForm},
      data(){
            return{
                  isOrderValid: false,
                  Order:{
                        Id:0,
                        IsOnly1DistancePD:false,
                        IsOnly1NearPD:false,
                        IsSpecialOrderNecessary:false,
                        ShippingUseDifferent:false,
                        DoesNotMeetRequirements:false,
                        JobType:'',
                        LensTreatment:[],
                        LensType:{},
                        LensTypeCode:'',
                        ReSph:'',
                        ReCyl:null,
                        ReAxis:null,
                        ReAdd:null,
                        ReSegHeight:null,
                        LeSph:null,
                        LeCyl:null,
                        LeAxis:null,
                        LeAdd:null,
                        LeSegHeight:null,
                        ReDistPD:null,
                        LeDistPD:null,
                        ReNearPD:null,
                        LeNearPD:null,
                        NearPD:null,
                        DistancePD:null,
                        LensDesign:null,
                        LensDesignObject:{
                              designCode:null
                        },
                        LensMaterial:null,
                        LensMaterialObject:{
                              code:null
                        },
                        FrameType:null,
                        EyeDoctorId: null,
                        PatFirstName: null,
                        PatLastName: null,
                        ReferralOrg: null,
                        ReferralCode: null,
                        PatDOB: null,
                        PatGender: null,
                        PatIsFirstTimeGlassesWearer: null,
                        PatEthnicity: null,
                        PatIsFirstTimeEyeExam: null,
                        JobType: null,
                        FrameManufacturer: null,
                        FrameId: 0,
                        FrameBrand: null,
                        FrameModel: null,
                        FrameColor: null,
                        FrameEyeSize: null,
                        FrameTempleLength: null,
                        ShippingFullName: null,
                        ShippingAddressLineOne: null,
                        ShippingAddressLineTwo: null,
                        ShippingSuite: null,
                        ShippingCity: null,
                        ShippingState: null,
                        ShippingPostcode: null,
                        isFirstLoad:false,
                        IsReuse:false,
                        SpecialLabInstructions:null,
                        AccountDetails:{},
                        PortalUserSalesforceId:null,
                        OrderLab:null,
                        Age:null,
                        DateSubmitted: new Date(),
                        OriginalFrameChoice: null,
                        SecondaryFrameChoice: null,
                        IsInternationalMission:false,
                        IsRemakeRedo:false,
                        RemakeRedoComments: null,
                        RemakeRedoReason: null,
                        IsExtra:false,
                        OriginId:null,
                        IsExamOnly: false,
                        DemographicId: 0,
                        OtherReferral: null,
                        ReferenceNoPo: null,
                        DispenserNotes: null,
                        FrameFpc: null,
                        IncludeAdditionalRxFields: false,
                        REHorizontalPrismValue: null,
                        REHorizontalPrismDirection: null,
                        REVerticalPrismValue: null,
                        REVerticalPrismDirection: null,
                        REOCHeight: null,
                        LEHorizPrismDirection: null,
                        LEVerticalPrismDirection: null,
                        LEHorizontalPrismValue: null,
                        LEHorizontalPrismDirection: null,
                        LEVerticalPrismValue: null,
                        LEVerticalPrismDirection: null,
                        LEOCHeight: null,
                        FrameCollection: null,
                        LabBillTo: null,
                        LabDefaultShipTo: null,
                        LabId: null,
                        ShipToAccountOverride: null,
                        RemakeSourceOrderId: null,
                        OrderLabInfoId: 0,
                        SupplierName: null,
                        PrescribingDoctorObject:{
                              salesforceId:null
                        },
                        ClinicEvent:null,
                        SchoolOrganization:null,
                        ClinicEventName:null,
                        SchoolOrganizationName:null,
                        RequiredClinicEvent:false,

                        ReManifestAcuity : "",
                        LeManifestAcuity : "",
                        PatWearingInstructions : "",

                        StudentID : "",
                        TeacherRoomNum : "",
                        IsReferredForEval : false,
                        ReferralReasons : "",
                        ReferralReasonsArray : [],
                        ReferralNotes : "",
                        IsUsingStockLensLab : false,
                        DoNotRequireFrameMeasurement: false,
                  },
                  OrderReturn:{},
                  errorMessage:'',
                  isSuccess: false,
                  AccountEnums :[
                        'Ethnicity',
                        'ReferralOrg',
                        'Suffix',
                        'State',
                        'PrismDirection'
                  ],
                  Ethnicity:{},
                  ReferralOrgSelect:{},
                  Suffix:{},
                  State:{},
                  PrismDirection:{},
                  ValidationResult: {},
                  Account:{primaryContact:{ officeLocation:{} }, accountType:0},
                  VoucherList:[],
                  isLoadFinish:false,
                  isVoucherLoadFinish:false,
                  isSubmitFinish:false,
                  isSubmitFail:false,
                  isSubmitPending:false,
                  isAccountFinishLoading:false,
                  isModalReviewShown:false,
                  ToSave:null,
                  IsPending:null,
                  MasterAccountType:null,
                  AccountStatus:null,
                  Capping:{frameLensCount:1},
                  isThreshHoldShown:false,
                  isorderCapMet:false,
                  showHelpForm:false,
                  Voucher:{
                        Payment:false
                  },
                  isSaveChangesModalShown: false,
                  goToNext: null,
                  countDownTimer:null,
                  OrderSaveChanges: false,
                  submitPendingSave: false,
                  examOnlySave: false
            }
      },
      methods: {
            GetSelectValues(){
                  var _this = this;
                  axios.post('/Util/GetEnums', this.AccountEnums, {headers: {'Authorization': "Bearer " + localStorage.getItem("token")}})
                        .then(function (response) {
                             _this.Ethnicity = response.data.raw.Ethnicity;
                             _this.Suffix = response.data.raw.Suffix;
                             _this.ReferralOrgSelect = response.data.raw.ReferralOrg;
                             _this.State = response.data.raw.State;
                             _this.PrismDirection = response.data.raw.PrismDirection;
                        })
                        .catch(function (error) {
                        console.log('ERROR:', error);
                        });
            },
            AccountValue(value){
                  this.Account = value;
            },
            SubmitExamOnlyOrder() {
              var _this = this;
              this.isSubmitFinish =true;
              this.isSubmitFail = false;
              this.Order.AccountDetails = this.Account;
              this.Order.DateSubmitted = new Date();
              this.Order.ReferralReasons = this.Order.ReferralReasonsArray.toString();

              if (this.MasterAccountType) {
                this.Order.AccountId = parseInt(this.Account.id);
              }
              if (this.Account.accountType == 1) {
                this.Order.EyeDoctorId = this.Account.primaryContact.salesforceId;
              }
              axios.post('/Order/SaveChanges/', this.Order, {headers: {'Authorization': "Bearer " + localStorage.getItem("token")}})
                .then(function (response) {
                  _this.isSubmitFinish = false;
                  if(response.data.isSuccess == false){
                    _this.isSubmitFail = true;
                    _this.ValidationResult = response.data.raw.validationResult;
                    _this.$scrollTo("#errorDivOrder", 300, {
                      el: "#errorDivOrder",
                      offset: -100,
                      x: false,
                      y: true
                    });
                  }else{
                    _this.Order.Id = response.data.raw.id;
                    _this.examOnlySave = true;
                    _this.$router.push({name: 'ExamConfirmation',  params: {code:_this.Order.Id, isSummaryOnly: '0'}});
                    // _this.$router.push({name: 'OrderConfirmation',  params: {code:response.data.raw.id, isSummaryOnly: "1"}});
                    _this.isSubmitFail = false;
                  }
                })
                .catch(function (error) {
                  console.log('ERROR:', error);
                  _this.$router.push({name: 'Error'});
                });
            },
            ValidateOrder(isSave, isReview, isPending, masterAccountApprove){

                  if(this.Order.ShippingAddressLineOne){
                        // this.Order.ShippingAddressLineOne = this.RemovePOBOX(this.Order.ShippingAddressLineOne);
                        let check_PO_BOX  = this.checkIfAddressHasPO_BOX(this.Order.ShippingAddressLineOne)
                        if(check_PO_BOX == true){
                        alert("Sorry, our labs cannot ship to a PO BOX. Please enter a valid shipping address.")
                        return
                        }
                  }
                  var _this = this;
                  this.isSubmitFinish =true;
                  this.isSubmitFail = false;
                  this.Order.ToSave = isSave;
                  this.Order.IsPending = isPending;
                  this.Order.AccountDetails = this.Account;
                  this.Order.DateSubmitted = new Date();
                  this.Order.PortalUserSalesforceId = _this.Account.portalUserSalesforceId;

                  if(this.Order.JobType == "FTC"){
                        this.Order.FrameEyeSize = this.Order.FrameEyeSize; // (this.Order.FrameEyeSize == null || this.Order.FrameEyeSize == '') ? "50" : this.Order.FrameEyeSize;
                        this.Order.FrameDBL = this.Order.FrameDBL // (this.Order.FrameDBL == null || this.Order.FrameDBL == '') ? "18" : this.Order.FrameDBL;
                        this.Order.FrameBBox = null
                        this.Order.FrameED =  null
                  }
                  if(this.Order.JobType == "UNC" ){
                        this.Order.FrameEyeSize = this.Order.FrameEyeSize; // (this.Order.FrameEyeSize == null || this.Order.FrameEyeSize == '') ? "50" : this.Order.FrameEyeSize;
                        this.Order.FrameDBL = this.Order.FrameDBL // (this.Order.FrameDBL == null || this.Order.FrameDBL == '') ? "18" : this.Order.FrameDBL;
                        this.Order.FrameBBox = this.Order.FrameBBox // (this.Order.FrameBBox == undefined || this.Order.FrameBBox == '') ? ((this.Order.FrameEyeSize) * .825) : this.Order.FrameBBox;
                        this.Order.FrameED =  (this.Order.FrameED == undefined || this.Order.FrameED == '') ? ((this.Order.FrameEyeSize) * 1.05) : this.Order.FrameED;
                  }

                  this.Order.PortalUserSalesforceId = _this.Account.portalUserSalesforceId;
                  if(this.Order.IsRemakeRedo){
                        if((this.Order.RemakeRedoReason != null) || (this.Order.RemakeRedoReason != null)){
                              this.Order.LensTreatment = this.Order.LensTreatment.filter(item => item !== "OTH-LABREDO")
                              this.Order.LensTreatment = this.Order.LensTreatment.filter(item => item !== "OTH-OPTERROR")
                              this.Order.LensTreatment = this.Order.LensTreatment.filter(item => item !== "OTH-OPENSOFT")
                              this.Order.LensTreatment.push(this.Order.RemakeRedoReason)
                        }
                  }
                  if(this.MasterAccountType){
                        this.Order.AccountId = parseInt(this.Account.id);
                  }
                  if(this.Account.accountType == 1){
                        this.Order.EyeDoctorId = this.Account.primaryContact.salesforceId;
                  }
                  this.Order.ReferralReasons = this.Order.ReferralReasonsArray.toString();
                  axios.post('/Order/SaveChanges/', this.Order, {headers: {'Authorization': "Bearer " + localStorage.getItem("token")}})
                        .then(function (response) {
                              _this.isSubmitFinish = false;
                              if(response.data.isSuccess == false){
                                    _this.isSubmitFail = true;
                                    _this.ValidationResult = response.data.raw.validationResult;
                                    _this.$scrollTo("#errorDivOrder", 300, {
                                          el: "#errorDivOrder",
                                          offset: -100,
                                          x: false,
                                          y: true
                                    });
                              }else{
                                    _this.Order.Id = response.data.raw.id;
                                    _this.submitPendingSave = true;
                                    if(isSave == 'false'){
                                          _this.isModalReviewShown = true;
                                           document.body.classList.add("body-overflow");
                                          _this.OrderReturn = response.data.raw;
                                    }else{
                                          if(isReview == 'false'){
                                                 _this.$router.push({name: 'OrderSubmit', params:{code:response.data.raw.id, type: 0}});
                                          }else{
                                                if(response.data.raw.orderStatus == 'PendingError' || response.data.raw.orderStatus == 'Review'){
                                                       _this.$router.push({name: 'OrderSubmit', params:{code:response.data.raw.id, type: 3}});
                                                }else{
                                                      if(response.data.raw.isSpecialOrderNecessary == true && masterAccountApprove == 'false'){
                                                            _this.$router.push({name: 'OrderSubmit', params:{code:response.data.raw.id, type: 1}});
                                                      }else{
                                                            _this.$router.push({name: 'OrderConfirmation',  params: {code:response.data.raw.id, isSummaryOnly: "1"}});
                                                      }
                                                }
                                          }
                                          document.body.classList.remove("body-overflow");
                                    }
                                    _this.isSubmitFail = false;
                              }
                        })
                        .catch(function (error) {
                              console.log('ERROR:', error);
                              _this.$router.push({name: 'Error'});
                        });

            },
            GetAccountValues(){
                  var _this = this;
                  if(!this.MasterAccountType){
                        axios.get('/Account/Self', {headers: {'Authorization': "Bearer " + localStorage.getItem("token")}})
                        .then(function (response) {
                              if(_this.$route.params.code == null){
                                    _this.isLoadFinish = true;
                              }
                              _this.isAccountFinishLoading = true;
                              _this.Account = response.data.raw;

                              if(_this.Account.primaryContact.officeLocation.streetAddress) _this.Account.primaryContact.officeLocation.streetAddress = _this.RemovePOBOX(_this.Account.primaryContact.officeLocation.streetAddress);
                              localStorage.setItem("portalUserSalesforceId", _this.Account.portalUserSalesforceId);
                              localStorage.setItem("customUserPermissionFlag", _this.Account.customUserPermissionFlag);

                              localStorage.setItem("stock_Lens_Account_Number__c", _this.Account.stock_Lens_Account_Number__c);
                              localStorage.setItem("stock_Lens_Lab_Assignment__c", _this.Account.stock_Lens_Lab_Assignment__c);
                              localStorage.setItem("stock_Lens_Lab_Bill_To__c", _this.Account.stock_Lens_Lab_Bill_To__c);
                              localStorage.setItem("stock_Lens_Lab_ID__c", _this.Account.stock_Lens_Lab_ID__c);
                              localStorage.setItem("stock_Lens_Lab_PCAT__c", _this.Account.stock_Lens_Lab_PCAT__c);
                              localStorage.setItem("stock_Lens_Lab_Ship_To__c", _this.Account.stock_Lens_Lab_Ship_To__c);
                              localStorage.setItem("stock_Lens_Lab_Ship_to_Override__c", _this.Account.stock_Lens_Lab_Ship_to_Override__c);


                              _this.Order.RequiredClinicEvent = _this.Account.customUserPermissionFlag.includes("Show Clinics and Schools");
                              _this.Order.ShowExtraStudentFields = _this.Account.customUserPermissionFlag.includes("Show Extra Student Fields");
                        })
                        .catch(function (error) {
                              console.log('ERROR:', error);
                        });
                  }else{
                        this.isLoadFinish = true;
                        this.isAccountFinishLoading = true;
                  }
            },
            GetOrderCount(){
                  var _this = this;
                  axios.get('order/GetOrderCount', {headers: {'Authorization': "Bearer " + localStorage.getItem("token")}})
                        .then(function (response) {
                              _this.Capping = response.data.raw;
                              if(((_this.Capping.orderCap -_this.Capping.orderCount) <= _this.Capping.orderThreshold) && (_this.Capping.orderCount < _this.Capping.orderCap) && (_this.MasterAccountType != 'master') && _this.Capping.isOrderCapOn){
                                    _this.isThreshHoldShown = true;
                              }
                              if(_this.Capping.orderCount >= _this.Capping.orderCap && _this.MasterAccountType != 'master' && _this.Capping.isOrderCapOn){
                                    _this.isorderCapMet = true;
                              }
                        })
                        .catch(function (error) {
                              console.log('ERROR:', error);
                        });
            },
            GetVouchers(){
                  var _this = this;
                  axios.get('/Order/ListVoucher', {headers: {'Authorization': "Bearer " + localStorage.getItem("token")}})
                  .then(function (response) {
                        _this.VoucherList = response.data.raw;
                        _this.isVoucherLoadFinish = true;
                  })
                  .catch(function (error) {
                        console.log('ERROR:', error);
                  });
            },
            setOriginalOrder(){
                  localStorage.setItem("originalOrder", JSON.stringify(this.Order));
            },
            EditForm(){
                  this.isOrderValid = true;
                  if(this.$route.params.code){
                        this.isLoadFinish = false;
                        var _this = this;
                        var retVal = null;
                        var framePageVisible = localStorage.getItem("frameAndLensOrderIsAllowed");
                        axios.get('/Order/Get/' + this.$route.params.code, {headers: {'Authorization': "Bearer " + localStorage.getItem("token")}})
                        .then(function (response) {
                              _this.isLoadFinish = true;
                              if (response.data.isSuccess == false){
                                    _this.isOrderValid = false;
                              }
                              else
                              {
                                    _this.isOrderValid = true;
                                    retVal = response.data.raw;

                                    if((_this.$route.params.EditOrReuse != 1) && (_this.$route.params.EditOrReuse != 3)){
                                          _this.Order.Id = retVal.id;
                                          _this.Order.IsRemakeRedo = retVal.isRemakeRedo;
                                          _this.Order.RemakeRedoComments = retVal.remakeRedoComments;
                                          _this.Order.RemakeRedoReason = retVal.remakeRedoReason;
                                          _this.Order.IsExtra = retVal.isExtra;
                                          _this.Order.OriginId = retVal.originId;
                                    }else{
                                          if (_this.$route.params.EditOrReuse == 3) {
                                                _this.Order.Id = 0;
                                                _this.Order.IsReuse = false;
                                                _this.Order.IsRemakeRedo = false;
                                                _this.Order.RemakeRedoComments = null;
                                                _this.Order.RemakeRedoReason = null;
                                                _this.Order.RemakeSourceOrderId = retVal.remakeSourceOrderId;
                                                _this.Order.OriginId = retVal.originId;
                                                _this.Order.IsExtra = true;
                                          } else {
                                                _this.Order.IsReuse = true;
                                                _this.Order.IsRemakeRedo = true;
                                                _this.Order.RemakeSourceOrderId = retVal.remakeSourceOrderId;
                                                _this.Order.RemakeRedoComments = retVal.remakeRedoComments;
                                                _this.Order.RemakeRedoReason = retVal.remakeRedoReason;
                                                _this.Order.OriginId = retVal.originId;
                                          }
                                    }

                                    if((_this.$route.params.EditOrReuse == 2) || (_this.$route.params.EditOrReuse == 3))
                                    {
                                          _this.Order.IsExamOnly = false;
                                    }
                                    else {
                                          _this.Order.IsExamOnly = retVal.isExamOnly;
                                          _this.Order.OriginId = retVal.originId;
                                    }

                                    _this.Order.OrderId = retVal.orderId;
                                    _this.Order.FrameId = retVal.frameId;
                                    _this.Order.IsOnly1DistancePD = retVal.isOnly1DistancePD;
                                    _this.Order.IsOnly1NearPD = retVal.isOnly1NearPD;
                                    _this.Order.IsSpecialOrderNecessary = retVal.isSpecialOrderNecessary;
                                    _this.Order.DoesNotMeetRequirements = retVal.doesNotMeetRequirements;
                                    _this.Order.ShippingUseDifferent = retVal.shippingUseDifferent;
                                    _this.Order.PatGender = retVal.patGender;
                                    _this.Order.OrderStatus = retVal.orderStatus;
                                    _this.Order.OriginId = retVal.originId;

                                    if(framePageVisible == "true"){
                                    _this.Order.JobType = retVal.jobType;
                                    }
                                    else if(retVal.jobType != "LSF")
                                    {
                                    _this.Order.JobType = retVal.jobType;
                                    }
                                    else
                                    {
                                    _this.Order.JobType = null;
                                    }
                                    if(_this.MasterAccountType == 'master'){
                                    _this.Account = retVal.accountDetails;
                                    _this.Order.JobType = retVal.jobType;
                                    }
                                    _this.Order.LensTreatment = retVal.lensTreatment;
                                    _this.Order.LensTypeCode = retVal.lensTypeCode;
                                    _this.Order.ReSph = retVal.reSph;
                                    _this.Order.ReCyl = retVal.reCyl;
                                    _this.Order.ReAxis = retVal.reAxis;
                                    _this.Order.ReAdd = retVal.reAdd;
                                    _this.Order.ReSegHeight = retVal.reSegHeight;
                                    _this.Order.LeSph = retVal.leSph;
                                    _this.Order.LeCyl = retVal.leCyl;
                                    _this.Order.LeAxis = retVal.leAxis;
                                    _this.Order.LeAdd = retVal.leAdd;
                                    _this.Order.LeSegHeight = retVal.leSegHeight;
                                    _this.Order.ReDistPD = retVal.reDistPD;
                                    _this.Order.LeDistPD = retVal.leDistPD;
                                    _this.Order.ReNearPD = retVal.reNearPD;
                                    _this.Order.LeNearPD = retVal.leNearPD;
                                    _this.Order.NearPD = retVal.nearPD;
                                    _this.Order.DistancePD = retVal.distancePD;
                                    _this.Order.LensDesign = retVal.lensDesign;
                                    _this.Order.LensMaterial = retVal.lensMaterial;
                                    _this.Order.EyeDoctorId = retVal.eyeDoctorId;
                                    _this.Order.PatFirstName = retVal.patFirstName;
                                    _this.Order.PatLastName = retVal.patLastName;
                                    _this.Order.ReferralOrg = retVal.referralOrg;
                                    _this.Order.ReferralCode = retVal.referralCode;
                                    _this.Order.PatDOB = retVal.patDOB;
                                    _this.Order.PatIsFirstTimeGlassesWearer = retVal.patIsFirstTimeGlassesWearer;
                                    _this.Order.PatEthnicity = retVal.patEthnicity;
                                    _this.Order.PatIsFirstTimeEyeExam = retVal.patIsFirstTimeEyeExam;
                                    _this.Order.FrameManufacturer = retVal.frameManufacturer;
                                    _this.Order.FrameBrand = retVal.frameBrand;
                                    _this.Order.FrameModel = retVal.frameModel;
                                    _this.Order.FrameType = retVal.frameType;
                                    _this.Order.FrameColor = retVal.frameColor;
                                    _this.Order.FrameEyeSize = retVal.frameEyeSize;
                                    _this.Order.FrameDBL = retVal.frameDBL;
                                    _this.Order.FrameED = retVal.frameED;
                                    _this.Order.FrameCheckMeasurements = retVal.frameCheckMeasurements;
                                    _this.Order.FrameBBox = retVal.frameBBox;
                                    _this.Order.FrameTempleLength = retVal.frameTempleLength;
                                    _this.Order.ShippingFullName = retVal.shippingFullName;
                                    _this.Order.ShippingAddressLineOne = _this.RemovePOBOX(retVal.shippingAddressLineOne);
                                    _this.Order.ShippingAddressLineTwo = _this.RemovePOBOX(retVal.shippingAddressLineTwo);
                                    _this.Order.ShippingSuite = retVal.shippingSuite;
                                    _this.Order.ShippingCity = retVal.shippingCity;
                                    _this.Order.ShippingState = retVal.shippingState;
                                    _this.Order.ShippingPostcode = retVal.shippingPostcode;
                                    _this.Order.DispenserNotes = retVal.dispenserNotes;
                                    _this.Order.SpecialLabInstructions = retVal.specialLabInstructions;
                                    _this.Order.SpecialInstructions1 = retVal.specialInstructions1;
                                    _this.Order.OrderLab = retVal.orderLab;
                                    _this.Order.ErrorMessage = retVal.errorMessage;
                                    _this.Order.isFirstLoad = true;
                                    _this.Order.OriginalFrameChoice = retVal.originalFrameChoice;
                                    _this.Order.SecondaryFrameChoice = retVal.secondaryFrameChoice;
                                    _this.Order.FrameFpc = retVal.frameFpc;
                                    _this.Order.IsInternationalMission = retVal.isInternationalMission;
                                    _this.Order.Age = retVal.age;
                                    _this.Order.PatEthnicity = retVal.patEthnicity;
                                    _this.Order.PatGender = retVal.patGender;
                                    _this.Order.PatIsFirstTimeEyeExam = retVal.patIsFirstTimeEyeExam;
                                    _this.Order.PatIsFirstTimeGlassesWearer = retVal.patIsFirstTimeGlassesWearer;
                                    _this.Order.DemographicId = retVal.demographicId;
                                    _this.Order.OtherReferral = retVal.otherReferral;
                                    _this.Order.ReferenceNoPo = retVal.referenceNoPo;
                                    _this.Order.IncludeAdditionalRxFields = retVal.includeAdditionalRxFields;
                                    _this.Order.REHorizontalPrismValue = retVal.reHorizontalPrismValue;
                                    _this.Order.REVerticalPrismValue = retVal.reVerticalPrismValue;
                                    _this.Order.LEHorizontalPrismValue = retVal.leHorizontalPrismValue;
                                    _this.Order.LEVerticalPrismValue = retVal.leVerticalPrismValue;

                                    _this.Order.REHorizontalPrismDirection = _this.ConvertToTitleCase(retVal.reHorizontalPrismDirection);
                                    _this.Order.REVerticalPrismDirection = _this.ConvertToTitleCase(retVal.reVerticalPrismDirection);
                                    _this.Order.LEHorizontalPrismDirection = _this.ConvertToTitleCase(retVal.leHorizontalPrismDirection);
                                    _this.Order.LEVerticalPrismDirection = _this.ConvertToTitleCase(retVal.leVerticalPrismDirection);
                                    _this.Order.LEOCHeight = retVal.leocHeight;
                                    _this.Order.REOCHeight = retVal.reocHeight;
                                    _this.Order.FrameCollection = retVal.frameCollection;
                                    _this.Order.LabBillTo = retVal.labBillTo;
                                    _this.Order.LabDefaultShipTo = retVal.labDefaultShipTo;
                                    _this.Order.LabId = retVal.labId;
                                    _this.Order.ShipToAccountOverride = retVal.shipToAccountOverride;
                                    _this.Order.SupplierName = retVal.supplierName;
                                    _this.Order.OrderLabInfoId = retVal.orderLabInfoId;
                                    _this.Order.ClinicEvent = retVal.clinicEvent;
                                    _this.Order.SchoolOrganization = retVal.schoolOrganization;
                                    _this.Order.ClinicEventName = retVal.clinicEventName;
                                    _this.Order.SchoolOrganizationName = retVal.schoolOrganizationName;

                                    _this.Order.ReManifestAcuity = retVal.patientDemographic.reManifestAcuity
                                    _this.Order.LeManifestAcuity = retVal.patientDemographic.leManifestAcuity
                                    _this.Order.PatWearingInstructions = retVal.patientDemographic.patWearingInstructions

                                    _this.Order.StudentID = retVal.patientDemographic.studentID
                                    _this.Order.TeacherRoomNum = retVal.patientDemographic.teacherRoomNum
                                    _this.Order.IsReferredForEval = retVal.patientDemographic.isReferredForEval
                                    _this.Order.ReferralReasons = retVal.patientDemographic.referralReasons
                                    _this.Order.ReferralNotes = retVal.patientDemographic.referralNotes
                                    _this.Order.ReferralReasonsArray = retVal.patientDemographic.referralReasons != null ? retVal.patientDemographic.referralReasons.split(',') : []
                                    localStorage.setItem('orderObj', JSON.stringify(_this.Order));
                              }
                        })
                        .catch(function (error) {
                              console.log('ERROR:', error);
                              _this.$router.push({name: 'Error'});
                        });
                  }
            },
            showModal() {
                  document.body.classList.add("body-overflow");
                  this.isModalReviewShown = ! this.isModalReviewShown;
            },
            closeModal() {
                  this.isModalReviewShown = false;
                  this.submitPendingSave = false;
                  document.body.classList.remove("body-overflow");
            },
            ToggleHelpForm(){
                this.showHelpForm = !this.showHelpForm;
            },
            CloseSaveChangesModal(value) {
                  this.goToNext = value;
                  this.isSaveChangesModalShown = false;
                  document.body.classList.remove("body-overflow");
            }
      },
      created(){
            this.MasterAccountType = localStorage.getItem("accountType");
            this.GetVouchers();
            this.GetSelectValues();
            this.GetAccountValues();
            this.EditForm();
            this.setOriginalOrder();
            this.AccountStatus = localStorage.getItem("accountStatus");
            if(this.MasterAccountType != 'master'){
                  this.GetOrderCount();
            }
            localStorage.setItem('is-active','order');
            localStorage.removeItem('orderObj');
            localStorage.setItem('orderObj', JSON.stringify(this.Order));
      },
      beforeRouteLeave (to, from, next) {
            if(!this.OrderSaveChanges || this.isModalReviewShown || this.submitPendingSave || this.examOnlySave){
                  next();
            }
            else {
                  var _confirm = confirm('Are you sure you want to leave this page? Your order information will not be saved.  To save the info, please select “Save as Pending Order” at the bottom of the page.');
                        if(_confirm){
                              localStorage.setItem('logout_session_acc', true);
                              next();
                        }
                        else {
                              localStorage.setItem('logout_session_acc', false);
                        }
            }
      },
      watch: {
            Order: {
                  // WATCH THE ORDER OBJECT IF THERE ARE CHANGES FOR SAVE ALERT PURPOSES
                  handler: function(val, oldVal) {
                        var tempOldObject = JSON.parse(localStorage.getItem("orderObj"));
                        // REMOVE UNDEFINED ITEMS IN OLD ORDER OBJECT
                        if(val.LensTypeCode == undefined){
                              tempOldObject.LensTypeCode = val.LensTypeCode;
                        }
                        var _oldObject = JSON.stringify(tempOldObject);
                        var oldObject = JSON.parse(_oldObject);
                        var _newOjb = JSON.stringify(val);
                        var newObject = JSON.parse(_newOjb);

                        // CONVERT VALUES OF ORDER OBJECT TO ARRAY
                        var oldArray = Object.keys(oldObject).map(function(k) { return oldObject[k] });
                        var newArray = Object.keys(newObject).map(function(k) { return newObject[k] });

                        var arrCtr = 0;
                        var undefinedCtr = 0;
                        var hasChangesCount = 0;
                        var getUndefined = [];
                        var hasChanges = false;

                        oldArray.forEach(element => {
                              if(newArray[arrCtr] === undefined){
                                    undefinedCtr++;
                              }
                              if(newArray[arrCtr] == element){
                                    // MATCHED ITEM
                              }
                              else {
                                    if (typeof newArray[arrCtr + undefinedCtr] === 'string' || newArray[arrCtr] instanceof String){
                                          if(newArray[arrCtr] != ""){
                                                hasChanges = true;
                                                hasChangesCount++;
                                          }
                                    }
                                    else {
                                          // To catch all objects, arrays and undefined
                                    }
                              }
                              arrCtr++;
                        });

                        if(hasChangesCount == 2 && newObject.DateSubmitted != null) {
                              this.OrderSaveChanges = false;
                        }
                        // else if(hasChangesCount == 0 &&  newObject.DispenserNotes != ''){
                        //       this.OrderSaveChanges = true;
                        // }
                        else if(hasChanges)
                              this.OrderSaveChanges = true;
                        else {
                                    this.OrderSaveChanges = false;
                        }
                  },
                  deep: true
            }
      }
}
</script>



// WEBPACK FOOTER //
// Order.vue?0ebf491d